import { partition, concat } from "lodash";
import { useState } from "react";
import { getCombinedSortedTags } from "./sub-components/ExpandableBadgeList.utils";

const useSelectedValues = (tags, entityType) => {
  const [newTags, setNewTags] = useState([]);
  const [existingTags, newlyAddedTags] = partition(
    tags,
    (tag) => !newTags.find((newTag) => newTag.id === tag.tagId)
  );
  const addTag = (tag) => {
    setNewTags([...newTags, tag]);
  };

  return {
    addTag,
    newTags,
    tags: concat(
      getCombinedSortedTags(existingTags, entityType),
      newlyAddedTags
    ),
  };
};

export default useSelectedValues;
